import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import {
  DebriefingCalls,
  InlineFilters,
  PreparationCalls,
  useInlineFiltersContext
} from 'features/command-center';
import { INLINE_FILTERS_KEYS } from 'features/command-center/constants';
import { userHasRoles } from 'services/Authorization';
import { Roles } from 'UI/constants/roles';

import { ALL_COMPANY_VISIBILITY_ROLES } from './constants';

export const Interviews = () => {
  const { filters: contextFilters } = useInlineFiltersContext();
  const [filters, setFilters] = useState({});
  const finalFilters = { ...filters, ...contextFilters };

  const inlineFilters = userHasRoles([
    ...ALL_COMPANY_VISIBILITY_ROLES,
    Roles.Coach,
    Roles.RegionalDirector
  ])
    ? ['recruiters', 'industries', 'specialties', 'subspecialties', 'tenures']
    : ['industries', 'specialties', 'subspecialties', 'tenures'];

  const handleFiltersChange = selectedFilters => {
    setFilters(selectedFilters);
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <InlineFilters
          filters={inlineFilters}
          onFiltersChange={handleFiltersChange}
          persistenceKey={INLINE_FILTERS_KEYS.dominate.interviews}
        />
      </Grid>

      <Grid item xs={12}>
        <PreparationCalls filters={finalFilters} />
      </Grid>

      <Grid item xs={12}>
        <DebriefingCalls filters={finalFilters} />
      </Grid>
    </Grid>
  );
};
